// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"009e5486","32":"59020a3b","91":"e9e11f30","133":"87d4f3b8","176":"d042c205","313":"09b64288","326":"70207f0d","518":"b29e83c4","524":"9ba7ea09","606":"bfd4465a","850":"eb0ea955"}[chunkId] + ".chunk.js";
};